{
    "back": "Atrás",
    "cancel": "Cancelar",
    "done": "Listo",
    "field_error_any": "Por favor rellenar mínimo uno de estos campos: ${1}",
    "field_error_date_invalid": "Por favor indicar un fecha válida",
    "field_error_date_max": "La fecha debe ser ${1} o antes",
    "field_error_date_min": "La fecha debe ser ${1} o después",
    "field_error_email": "Por favor indicar email válido",
    "field_error_length_max": "Este campo está restringido a ${1} caracteres",
    "field_error_length_min": "Por favor indicar un mínimo de ${1} caracteres",
    "field_error_max": "El valor máximo es ${1}",
    "field_error_min": "El monto mínimo es ${1}",
    "field_error_phone_invalid": "Por favor indicar un número de teléfono válido",
    "field_error_phone_starts_with_zero": "Ya existe un código de país. Por favor, elimine el \"0\" del número de teléfono.",
    "field_error_required": "Por favor rellenar este campo",
    "field_placeholder_address_search": "Ingresa una ubicación",
    "field_select_not_found": "'${1}' no se encuentra",
    "link_sent": "Enlace enviado, por favor verifique",
    "network_error": "Error de red",
    "ok": "OK",
    "open": "Abierto",
    "retry": "Reintentar",
    "state_refused": "Rechazado",
    "state_uploading": "Subiendo",
    "uploading": "Subiendo..."
}